import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

// Language files
import ko from './ko.json';
import en from './en.json';
import de from './de.json';
import es from './es.json';
import fr from './fr.json';
import it from './it.json';
import ja from './ja.json';
import zhCN from './zh-CN.json';
import zhTW from './zh-TW.json';
import pl from './pl.json';
import cs from './cs.json';

const resources = {
  ko: { translation: ko },
  en: { translation: en },
  de: { translation: de },
  es: { translation: es },
  fr: { translation: fr },
  it: { translation: it },
  ja: { translation: ja },
  'zh-CN': { translation: zhCN },
  'zh-TW': { translation: zhTW },
  pl: { translation: pl },
  cs: { translation: cs },
};

// Supported languages with display names and flags
export const SUPPORTED_LANGUAGES = [
  { code: 'ko', name: '한국어', flag: '🇰🇷' },
  { code: 'en', name: 'English', flag: '🇺🇸' },
  { code: 'de', name: 'Deutsch', flag: '🇩🇪' },
  { code: 'es', name: 'Español', flag: '🇪🇸' },
  { code: 'fr', name: 'Français', flag: '🇫🇷' },
  { code: 'it', name: 'Italiano', flag: '🇮🇹' },
  { code: 'ja', name: '日本語', flag: '🇯🇵' },
  { code: 'zh-CN', name: '简体中文', flag: '🇨🇳' },
  { code: 'zh-TW', name: '繁體中文', flag: '🇹🇼' },
  { code: 'pl', name: 'Polski', flag: '🇵🇱' },
  { code: 'cs', name: 'Čeština', flag: '🇨🇿' },
];

// Get saved language or browser language
const getSavedLanguage = () => {
  const saved = localStorage.getItem('language');
  if (saved && SUPPORTED_LANGUAGES.some(lang => lang.code === saved)) {
    return saved;
  }
  // Try to match browser language
  const browserLang = navigator.language;
  if (SUPPORTED_LANGUAGES.some(lang => lang.code === browserLang)) {
    return browserLang;
  }
  // Try partial match (e.g., 'en-US' -> 'en')
  const shortLang = browserLang.split('-')[0];
  if (SUPPORTED_LANGUAGES.some(lang => lang.code === shortLang)) {
    return shortLang;
  }
  return 'ko'; // Default to Korean
};

i18n.use(initReactI18next).init({
  resources,
  lng: getSavedLanguage(),
  fallbackLng: 'ko',
  interpolation: {
    escapeValue: false,
  },
});

export default i18n;
